import { render, staticRenderFns } from "./mxMobile.vue?vue&type=template&id=63191be7&scoped=true"
import script from "./mxMobile.vue?vue&type=script&lang=js"
export * from "./mxMobile.vue?vue&type=script&lang=js"
import style0 from "./mxMobile.vue?vue&type=style&index=0&id=63191be7&prod&lang=less&scoped=true"
import style1 from "./mxMobile.vue?vue&type=style&index=1&id=63191be7&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63191be7",
  null
  
)

export default component.exports